// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".placeholder-image{display:flex;align-items:center;justify-content:center;background-color:#f4f4f4;height:var(--sizeWrapper);width:var(--sizeWrapper);position:relative}.placeholder-image__icon{height:var(--sizeIcon);width:var(--sizeIcon);max-height:100%;max-width:100%}.placeholder-image_circle{border-radius:50%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
